import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getProfileRoles } from 'modules/settings/api';

export const useQueryProfileRoles = () => {
  const { data, isLoading, error, refetch, isFetching } = useQuery(
    QUERY_KEYS.SETTINGS_PROFILE_ROLES,
    getProfileRoles,
  );

  return {
    profileRolesData: data,
    profileRolesLoading: isLoading,
    profileRolesError: error,
    profileRolesRefetch: refetch,
    profileRolesFetching: isFetching,
  };
};
